import {
  GET_CART_REQUESTING,
  GET_CART_SUCCESS,
  RESET_CART_ISFETCHING,
  SIDE_CART_VISIBLE,
  SIDE_CART_NOT_VISIBLE
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  isSideCartVisible: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIDE_CART_VISIBLE: {
      return {
        ...state,
        isSideCartVisible: true
      };
    }
    case SIDE_CART_NOT_VISIBLE: {
      return {
        ...state,
        isSideCartVisible: false
      };
    }
    case RESET_CART_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case GET_CART_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_CART_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
